import React from "react";
import Slider from "react-slick";
import { Typography, Button, Stack } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../App.css";
import person1 from "../assets/Images/Person1.png";
import person2 from "../assets/Images/Person2.png";
import person3 from "../assets/Images/Person3.png";
import person4 from "../assets/Images/Person4.png";
import person5 from "../assets/Images/Person5.png";
import person6 from "../assets/Images/Person6.png";
import starFilled from "../assets/Images/starFilled.png";
import starEmpty from "../assets/Images/starEmpty.png";
import { isMobile } from "react-device-detect";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "darkGrey",
        height: "18px",
        width: "20px",
        borderRadius: "50%",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "darkGrey",
        height: "18px",
        width: "20px",
        borderRadius: "50%",
      }}
      onClick={onClick}
    />
  );
}

const Testimonials = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: 1,
    arrows: isMobile ? false : true,
    // centerMode: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <>
      <div style={{ width: "90%", margin: "auto" }}>
        <Typography
          variant="h5"
          component="h1"
          style={{
            marginTop: "30px",
            fontWeight: "600",
            fontSize: "22px",
            lineHeight: "24px",
            marginBottom: "30px",
            textAlign: isMobile ? "center" : "start",
          }}
        >
          Hear from people around you
        </Typography>
        <Slider {...settings}>
          <div>
            <div className="testimonialBox">
              <div
                style={{
                  width: "90%",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Stack direction="row" spacing={2}>
                  <img src={person1} className="testimonialPerson" />
                  <Stack direction="column" spacing={1}>
                    <Typography variant="h6">Masson Mount</Typography>
                    <Stack direction="row" spacing={1}>
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starEmpty} />
                    </Stack>
                  </Stack>
                </Stack>
                <Typography variant="body1" className="testimonialDescription">
                  What a great experience using Amaanat! I booked all of my
                  services through Amannat and never had any issues.
                </Typography>
              </div>
            </div>
          </div>
          <div>
            <div className="testimonialBox">
              <div
                style={{
                  width: "90%",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Stack direction="row" spacing={2}>
                  <img src={person2} className="testimonialPerson" />
                  <Stack direction="column" spacing={1}>
                    <Typography variant="h6">Simon Cowell</Typography>
                    <Stack direction="row" spacing={1}>
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starEmpty} />
                    </Stack>
                  </Stack>
                </Stack>
                <Typography variant="body1" className="testimonialDescription">
                  What a great experience using Amaanat! I booked all of my
                  services through Amannat and never had any issues.
                </Typography>
              </div>
            </div>
          </div>{" "}
          <div>
            <div className="testimonialBox">
              <div
                style={{
                  width: "90%",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Stack direction="row" spacing={2}>
                  <img src={person3} className="testimonialPerson" />
                  <Stack direction="column" spacing={1}>
                    <Typography variant="h6">Taylor Swift</Typography>
                    <Stack direction="row" spacing={1}>
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starEmpty} />
                    </Stack>
                  </Stack>
                </Stack>
                <Typography variant="body1" className="testimonialDescription">
                  What a great experience using Amaanat! I booked all of my
                  services through Amannat and never had any issues.
                </Typography>
              </div>
            </div>
          </div>{" "}
          <div>
            <div className="testimonialBox">
              <div
                style={{
                  width: "90%",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Stack direction="row" spacing={2}>
                  <img src={person4} className="testimonialPerson" />
                  <Stack direction="column" spacing={1}>
                    <Typography variant="h6">Dominic Giles</Typography>
                    <Stack direction="row" spacing={1}>
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starEmpty} />
                    </Stack>
                  </Stack>
                </Stack>
                <Typography variant="body1" className="testimonialDescription">
                  What a great experience using Amaanat! I booked all of my
                  services through Amannat and never had any issues.
                </Typography>
              </div>
            </div>
          </div>{" "}
          <div>
            <div className="testimonialBox">
              <div
                style={{
                  width: "90%",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Stack direction="row" spacing={2}>
                  <img src={person5} className="testimonialPerson" />
                  <Stack direction="column" spacing={1}>
                    <Typography variant="h6">Sarah White</Typography>
                    <Stack direction="row" spacing={1}>
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starEmpty} />
                    </Stack>
                  </Stack>
                </Stack>
                <Typography variant="body1" className="testimonialDescription">
                  What a great experience using Amaanat! I booked all of my
                  services through Amannat and never had any issues.
                </Typography>
              </div>
            </div>
          </div>{" "}
          <div>
            <div className="testimonialBox">
              <div
                style={{
                  width: "90%",
                  margin: "auto",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Stack direction="row" spacing={2}>
                  <img src={person6} className="testimonialPerson" />
                  <Stack direction="column" spacing={1}>
                    <Typography variant="h6">Marcus Rashford</Typography>
                    <Stack direction="row" spacing={1}>
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starFilled} />
                      <img src={starEmpty} />
                    </Stack>
                  </Stack>
                </Stack>
                <Typography variant="body1" className="testimonialDescription">
                  What a great experience using Amaanat! I booked all of my
                  services through Amannat and never had any issues.
                </Typography>
              </div>
            </div>
          </div>
        </Slider>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "45px",
            marginBottom: "45px",
          }}
        >
          <Button variant="contained" style={{ textTransform: "capitalize" }}>
            Get Quote Now
          </Button>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
